import { request } from "../utils/request.js"


export const expenseOrder_exportForManage = (pojo, args) => request({
    url: 'expenseOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const expenseOrder_findPageForManage = (pojo, args) => request({
    url: 'expenseOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const expenseOrder_findPageListForManage = (pojo, args) => request({
    url: 'expenseOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const expenseOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'expenseOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const expenseOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'expenseOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const expenseOrder_saveIntoDraft = (pojo, args) => request({
    url: 'expenseOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const expenseOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'expenseOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const expenseOrder_update = (pojo, args) => request({
    url: 'expenseOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const expenseOrder_updateAndSubmit = (pojo, args) => request({
    url: 'expenseOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const expenseOrder_submitById = (id, args) => request({
    url: 'expenseOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const expenseOrder_deleteById = (id, args) => request({
    url: 'expenseOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const expenseOrder_approval = (pojo, args) => request({
    url: 'expenseOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const expenseOrder_findById = (id, args) => request({
    url: 'expenseOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/expenseOrder.js